import React, { useEffect, useState } from 'react';
import {Database, getUsername,} from '../services/serviceDB';
import FetchForms from '../utils/FetchForms';
import { getMontrealDate } from '../utils/GetISOlocalDate';
import { getId } from '../utils/GenerateID';


const resultDB = new Database("results")

const ListAvailablesForms = () => {
  const [formContent, setFormContent] = useState<any>({});
  const [formID, setFormID] = useState<any>({});

  const [latitude, setLatitude] = useState(Number);
  const [longitude, setLongitude] = useState(Number);


  const childToParent = (childdata) => {
    setFormID(childdata._id)
    setFormContent(childdata.form_content)
  }


  useEffect(() => {
    const location = window.navigator && window.navigator.geolocation;
    if(location) {
      location.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          setLatitude(-1);
          setLongitude(-1);
        })
    }

  }, []);
  

  const createForm = () => {
    const form = Object.keys(formContent).map(field => {
      // Handle select input
      if (formContent[field].input_type === "select") {
        return (
          <div key={field}>
            <label>{formContent[field].label}</label>
            <select name={formContent[field].label}>
              {formContent[field].values.map((item: any) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </div>
        )
      }
      // Handle checkbox input
      if (formContent[field].input_type === "checkbox") {
        return (
          <div key={field}>
            <label> {formContent[field].label}</label>
            <input type={formContent[field].input_type} name={formContent[field].label}/>
          </div>
        )
      }
      else {
        let defaultValue = formContent[field].value
        // Handle Date
        if (formContent[field].input_type === "date") {
          const today = new Date();
          const date = today.setDate(today.getDate()); 
          defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd          
        }
        // Handle everything else
        return (
          <div key={field}>
            <label>{formContent[field].label}</label>
            <input type={formContent[field].input_type} name={formContent[field].label} step="any" defaultValue={defaultValue}/>
          </div>
        )
      }
    })
    return form
  }


  const handleSubmit = async (event: any) => {
    event.preventDefault();
    let relevantData: any = {};
    for (let element of event.target.elements) {
      if (element.type === "checkbox") {
        relevantData[element.name] = element.checked;
      } else if (element.name) {
        relevantData[element.name] = element.value
        element.value = ''
      }
    }
    relevantData["form_id"] = formID
    relevantData["_id"] = getId()
    relevantData["posted_at"] = getMontrealDate()
    relevantData["posted_by"] = await getUsername()
    relevantData["longitude"] = longitude
    relevantData["latitude"] = latitude
    event.target.reset()
    await resultDB.local_database.put(relevantData).then(async function () {
      await resultDB.pushToRemote()
    })
  }
  
  
  return (
    <>
      {FetchForms({childToParent})}
      <form onSubmit={handleSubmit}>
        {createForm()}
        <input type="submit" value="Confirmer"/>
      </form>
    </>
  )
};
export default ListAvailablesForms;